/* MusicVideoForm.js */

import React, { useCallback, useEffect, useState } from 'react';
import { Container, Row, Col, Form, FormGroup, Label, Button, Card, CardBody, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { useForm } from 'react-hook-form';
import { SiYoutubemusic, SiApplemusic, SiSpotify, SiWhatsapp, SiInstagram, SiFacebook, SiYoutube, SiTiktok, SiTwitter } from "react-icons/si";
import { IoLinkOutline, IoTrashBinOutline } from "react-icons/io5";
import { useHistory, Prompt } from 'react-router-dom';
import { RemixCreator } from '../../utils/RemixCreator';
import Assets from '../../services/Assets';
import Strings from '../../translations/Translations';
import { useAuth } from '../../context/auth/AuthContext';
import RemixHelper from '../../helpers/RemixHelper';
import { StartagCreator } from '../../utils/StartagCreator';
import PlayIcon from '../../assets/img/play_icon.svg';
import Button1 from '../../components/buttons/Button1';
import { toast } from 'react-toastify';
import SocialLinksParser from '../../helpers/SocialLinksParser';
import PSO from '../../services/PSO';
import ModalSkin from '../modals/ModalSkin';
import TinyPagePreview from './TinyPagePreview';
import StickyBox from "react-sticky-box";
import ModalManageVideo from '../modals/ModalManageVideo';
import ModalPlugin from '../modals/ModalPlugin';
import ModalWhatsapp from '../modals/ModalWhatsapp';
import { getRemixCover } from '../../helpers/GetRemixCover';
import ModalSocialNetworkLink from '../modals/ModalSocialNetworkLink';
import ModalCoverPhoto from '../modals/ModalCoverPhoto';
import ModalOriginalSong from '../modals/ModalOriginalSong';
import Select from 'react-select';
import OriginalSongCard1 from '../media/OriginalSongCard1';
import ModalRemoveOriginalSong from '../modals/ModalRemoveOriginalSong';
import RemixExport from './RemixExport';
import { getCreditsCostLabel } from '../../helpers/GetCreditsCostLabel';

export default function MusicVideoForm({ createMode, editMode, openTinyPageAfterCreation = true, callBackAfterCreation, remixPars, remixStyle }) {
  const { authenticated, toggleLoading, checkCredits } = useAuth();
  const history = useHistory();
  const { register, handleSubmit, setValue, getValues, formState: { errors }, reset, watch } = useForm();
  const [isBlocking, setIsBlocking] = useState(false);

  const [loading, setLoading] = useState(false);
  const [modalManageVideoOpen, setModalManageVideoOpen] = useState(false);
  const [modalPluginOpen, setModalPluginOpen] = useState(false);
  const [modalSkinOpen, setModalSkinOpen] = useState(false);
  const [modalWhatsappOpen, setModalWhatsappOpen] = useState(false);
  const [modalSocialNetworkLinkOpen, setModalSocialNetworkLinkOpen] = useState(false);
  const [socialNetworkLinkInsert, setSocialNetworkLinkInsert] = useState();
  const [socialNetworkLinkInsertType, setSocialNetworkLinkInsertType] = useState();
  const [modalAddLinkOpen, setModalAddLinkOpen] = useState(false);
  const toggleModalAddLink = useCallback(() => setModalAddLinkOpen(!modalAddLinkOpen), [setModalAddLinkOpen, modalAddLinkOpen]);
  const [modalRemoveOriginalSongOpen, setModalRemoveOriginalSongOpen] = useState(false);

  const [remixMedia, setRemixMedia] = useState();
  const [categories, setCategories] = useState();
  const [genres, setGenres] = useState();
  const [links, setLinks] = useState([]);
  const [hashtags, setHashtags] = useState([]);
  const [style, setStyle] = useState();
  const [previousStyleId, setPreviousStyleId] = useState();
  const [skin, setSkin] = useState(1);
  const [title, setTitle] = useState(Strings('title'));
  const [description, setDescription] = useState(Strings('description'));
  const [originalSong, setOriginalSong] = useState();
  const [coverPhoto, setCoverPhoto] = useState();

  const [creditAction] = useState('createMusicVideo');
  const [labelCreditsCost, setLabelCreditsCost] = useState('');
  const hookGetCreditsCostLabel = useCallback(async () => {
    const { un, al } = authenticated;
    const creditsMultiplier = null;
    let creditsSecondaryAction = null;
    const label = await getCreditsCostLabel(un, al, creditAction, creditsMultiplier, creditsSecondaryAction);
    setLabelCreditsCost(label);
  }, [authenticated, creditAction]);
  useEffect(() => { hookGetCreditsCostLabel() }, [hookGetCreditsCostLabel]);

  const getTimestampInSeconds = () => { return Math.floor(Date.now() / 1000) };

  const addLink = useCallback((type, phone_number = null, direct_label = null, direct_url = null) => {
    let newLink;
    const timestamp = getTimestampInSeconds();
    if (type === 'instagram') { newLink = { id: `input_instagram_${timestamp}`, label: Strings('instagram'), url: 'https://instagram.com/' }; }
    else if (type === 'facebook') { newLink = { id: `input_facebook_${timestamp}`, label: Strings('facebook'), url: 'https://facebook.com/' }; }
    else if (type === 'twitter') { newLink = { id: `input_twitter_${timestamp}`, label: Strings('twitter'), url: 'https://twitter.com/' }; }
    else if (type === 'tiktok') { newLink = { id: `input_tiktok_${timestamp}`, label: Strings('tik_tok'), url: 'https://tiktok.com/' }; }
    else if (type === 'youtube') { newLink = { id: `input_youtube_${timestamp}`, label: Strings('youtube'), url: 'https://youtube.com/' }; }
    else if (type === 'spotify') { newLink = { id: `input_spotify_${timestamp}`, label: Strings('spotify'), url: 'https://spotify.com/' }; }
    else if (type === 'applemusic') { newLink = { id: `input_applemusic_${timestamp}`, label: Strings('apple_music'), url: 'https://music.apple.com/' }; }
    else if (type === 'youtubemusic') { newLink = { id: `input_youtubemusic_${timestamp}`, label: Strings('youtube_busic'), url: 'https://music.youtube.com/' }; }
    else if (type === 'whatsapp' && phone_number) {
      const whatsappUrl = `https://wa.me/${phone_number}`;
      newLink = { id: `input_whatsapp_${timestamp}`, label: 'Whatsapp', url: whatsappUrl };
    }
    else if (type === 'custom') { newLink = { id: `input_custom_${timestamp}`, label: Strings('website'), url: 'https://' }; }
    else if (type === 'direct' && direct_label && direct_url) {
      newLink = { id: `input_custom_${timestamp}`, label: direct_label, url: direct_url };
    }
    if (newLink) {
      const currentLinks = links;
      currentLinks.push(newLink);
      setLinks(currentLinks);
    }
    toggleModalAddLink();
  }, [links, setLinks, toggleModalAddLink]);

  const removeLink = useCallback((rIndex) => {
    const data = getValues();
    const newLinks = [];
    if (links && links.length > 0) {
      links.forEach((item, index) => {
        if (index !== rIndex) {
          const label = data[`${item.id}_label`];
          const value = data[item.id];
          newLinks.push({ id: item.id, label: label, 'url': value });
        }
      });
    }
    setLinks(newLinks);
  }, [links, setLinks, getValues]);

  const resetForm = useCallback(() => {
    reset();
  }, [reset]);

  const validateCreate = useCallback(async () => {
    let returnV = true, message;
    if (remixMedia === undefined || remixMedia.legnth === 0) {
      returnV = false;
      message = Strings('select_at_least_one_photo_for_the_video');
    }
    if (returnV) {
      if (style === undefined) {
        returnV = false;
        message = Strings('select_a_style_for_the_video');
      }
    }

    if (message) {
      toast.warning(message);
    }

    return returnV;
  }, [remixMedia, style]);

  const onSubmitCreate = useCallback(async (data) => {
    // Check CREDITS
    const creditsMultiplier = null;
    const creditsSecondaryAction = null;
    const userCanDoAction = await checkCredits(creditAction, creditsMultiplier, creditsSecondaryAction);
    if (!userCanDoAction) {
      return;
    }

    let returnV = true;

    returnV = await validateCreate();
    if (returnV) {
      setLoading(true);

      // Setting style and song ID
      let styleId = 101917, songId = 10031; // Default values
      if (style && style.id && style.ms) {
        styleId = style.id;
        songId = style.ms;
      } else if (data.category) {
        try {
          const styles = await Assets.getStyle(data.category);
          if (styles) {
            const randomStyle = styles[Math.floor(Math.random() * styles.length)];
            if (randomStyle && randomStyle.id && randomStyle.ms) {
              styleId = randomStyle.id;
              songId = randomStyle.ms;
            }
          }
        } catch (err) {
          returnV = false;
          toast.error(Strings('error_on_getting_random_style'));
          console.error(err);
        }
      } else {
        returnV = false;
      }

      // Processing hashtags for creation
      let hashTagsCreation = [];
      if (hashtags.length > 0) {
        hashTagsCreation = hashtags;
      } else {
        const targetCategory = categories.filter((item) => parseInt(item.id) === parseInt(data.category));
        if (targetCategory && targetCategory[0] && targetCategory[0].name) {
          hashTagsCreation.push(RemixHelper.processHashtagStyle(targetCategory[0].name));
        }
      }
      if (hashTagsCreation.length === 0) {
        hashTagsCreation.push('social');
      }

      // Getting skin
      let skinToCreate = 1; // Default value
      if (skin) { skinToCreate = skin; }
      else if (data.skin) { skinToCreate = data.skin }

      if (returnV) {
        // Generating startag
        const startag = await StartagCreator({ al: authenticated.al, un: authenticated.un, text: data.title });

        // Getting social links
        const socialLinks = [];
        if (links && links.length > 0) {
          links.forEach((item) => {
            if (data[item.id] && data[`${item.id}_label`]) {
              let link = data[item.id];
              link = link.replaceAll(' ', '');
              socialLinks.push({ 'label': data[`${item.id}_label`], link });
            }
          });
        }

        // Creating the Remix with the Remix Creator helper
        const creatorPars = {
          al: authenticated.al,
          un: authenticated.un,
          rstyle_sid: styleId,
          rsong_sid: songId,
          rti: data.title,
          rstag: startag,
          rde: RemixHelper.generateSocialLinksDescription(data.description, socialLinks, skinToCreate, hashTagsCreation),
          remixMedia: remixMedia,
          coverPhoto: coverPhoto
        };
        const result = await RemixCreator(creatorPars);
        if (result && result.returnV) {

          if (result.rid && originalSong && originalSong.eid) {
            try {
              const originalSongArgs = { usoid: originalSong.eid, uso: 1 };
              const originalSongResponse = await PSO.modifyRemix({
                un: authenticated.un,
                al: authenticated.al,
                rid: result.rid,
                args: originalSongArgs
              });
              if (originalSongResponse.result !== 'success') {
                const message = (originalSongResponse && originalSongResponse.error) ? originalSongResponse.error : Strings('error_on_request');
                toast.error(message);
              }
            } catch (err) {
              console.error(err);
            }
          }

          toast.success(Strings('music_video_page_successfully_created'));
          resetForm();

          if (result.tid && openTinyPageAfterCreation) {
            RemixHelper.openPopFansTinyPage(result.tid);
          }

          setIsBlocking(false);
          setTimeout(() => {
            // Callback After Social Link Creation
            if (callBackAfterCreation) { callBackAfterCreation(); }
          }, 500);
        } else if (result && result.message) {
          toast.error(result.message);
        }
      } else {
        console.error(Strings('error_on_creating_music_video'));
      }

      setLoading(false);
    }
  }, [authenticated, remixMedia, links, setLoading, openTinyPageAfterCreation, callBackAfterCreation, resetForm, hashtags, categories, style, skin, validateCreate, setIsBlocking, originalSong, coverPhoto, checkCredits, creditAction]);

  const onSubmitEdit = useCallback(async (data) => {
    let readyToEdit = false;
    const args = {};
    const { title, description } = data;

    if (title && remixPars && title !== remixPars.rti) {
      readyToEdit = true;
      args.rti = encodeURIComponent(title);
    }

    // Getting skin
    let skinToUpdate = 1; // Default value
    if (data.scapeSkin) { skinToUpdate = data.skin; }
    else if (skin) { skinToUpdate = skin; }
    else if (data.skin) { skinToUpdate = data.skin }

    // Generating rde
    const socialLinks = [];
    if (links && links.length > 0) {
      links.forEach((item) => {
        if (data[item.id] && data[`${item.id}_label`]) {
          let link = data[item.id];
          link = link.replaceAll(' ', '');
          socialLinks.push({ 'label': data[`${item.id}_label`], link });
        }
      });
    }
    const rde = RemixHelper.generateSocialLinksDescription(description, socialLinks, skinToUpdate, hashtags);
    if (rde) {
      readyToEdit = true;
      args.rde = encodeURIComponent(rde);
    }

    if (readyToEdit && remixPars && remixPars.rid) {
      setLoading(true);
      const response = await PSO.modifyRemix({
        un: authenticated.un,
        al: authenticated.al,
        rid: remixPars.rid,
        args
      });

      if (response.result === 'success') {
        toast.success(Strings('music_video_page_edited'));
      } else {
        const message = (response && response.error) ? response.error : Strings('error_on_request');
        toast.error(message);
      }
      setLoading(false);
    }
  }, [authenticated, links, setLoading, remixPars, hashtags, skin]);

  const getCategories = useCallback(async () => {
    toggleLoading(true);
    let categoriesSet, generalCategories, allCategories = [];

    try { categoriesSet = await Assets.getCategoriesSet(); }
    catch (err) { toast.error(`${Strings('error_while_getting_categories')} [ID==01]`); }

    try { generalCategories = await Assets.getCategories(); }
    catch (err) { toast.error(`${Strings('error_while_getting_categories')} [ID==02]`); }

    if (categoriesSet && categoriesSet.its && generalCategories) {
      let categoriesIds = [];
      categoriesSet.its.forEach((item) => {
        if (item.cats) { categoriesIds = [...categoriesIds, ...item.cats]; }
      });
      if (categoriesIds.length > 0) {
        let defaultValueSetted = false;
        categoriesIds.forEach((id) => {
          const targetCategory = generalCategories.its.filter((value) => { return parseInt(value.id) === id && parseInt(value.id) !== 3 && parseInt(value.id) !== 4 });
          if (targetCategory && targetCategory[0]) {
            allCategories.push({ id: id, name: targetCategory[0].la });
            if (!defaultValueSetted) {
              setValue('category', id);
              defaultValueSetted = true;
            }
          }
        });
      }
      if (allCategories.length > 0) { setCategories(allCategories); }
    }
    toggleLoading(false);
  }, [toggleLoading, setCategories, setValue]);
  useEffect(() => { getCategories() }, [getCategories]);

  const parseRemixPars = useCallback((remixPars) => {
    toggleLoading(true);

    const { rti, rde } = remixPars;
    if (rti) {
      setValue('title', rti);
      setTitle(rti);
    }
    if (rde) {
      const descriptionParts = SocialLinksParser.parse(rde);
      if (descriptionParts.description) { setValue('description', descriptionParts.description); }
      if (descriptionParts.links && descriptionParts.links.length > 0) {
        const linksToSet = [];
        descriptionParts.links.forEach((item, index) => {
          const timestamp = getTimestampInSeconds();
          item.id = `input_ready_${timestamp}_${index}`;
          linksToSet.push(item);
        });
        setLinks(linksToSet);
      }
      if (descriptionParts.hashtags && descriptionParts.hashtags.length > 0) { setHashtags(descriptionParts.hashtags); }
      if (descriptionParts.skin) { setSkin(descriptionParts.skin); }
      if (descriptionParts.description) { setDescription(descriptionParts.description); }
    }

    toggleLoading(false);
  }, [toggleLoading, setValue, setLinks, setHashtags, setDescription, setTitle]);
  useEffect(() => { if (remixPars) { parseRemixPars(remixPars); } }, [remixPars, parseRemixPars]);

  const updateStyle = useCallback(async (targetStyle) => {
    const undoStyleId = (previousStyleId) ? previousStyleId : remixStyle.eid;
    if (remixPars && remixPars.rid && targetStyle && targetStyle.id) {
      setLoading(true);
      try {
        const response = await PSO.replaceOldestExistingElementInRemix({
          un: authenticated.un,
          al: authenticated.al,
          rid: remixPars.rid,
          etype: 4,
          e_sid: targetStyle.id
        });

        if (response.result === 'success') {
          toast.success(
            <div className='d-flex justify-content-between'>
              <div>
                {Strings('music_video_page_edited')}
              </div>
              <div>
                <Button
                  color='secondary'
                  onClick={() => {
                    updateStyle({ id: undoStyleId });
                  }}
                >
                  {Strings('undo')}
                </Button>
              </div>
            </div>, { autoClose: 50000 }
          );
          setPreviousStyleId(undoStyleId);
        } else {
          const message = (response && response.error) ? response.error : Strings('error_on_request');
          toast.error(message);
        }
      } catch (err) {
        console.error(err);
      }
      setLoading(false);
    }
  }, [remixPars, setLoading, authenticated, previousStyleId, setPreviousStyleId, remixStyle]);

  const getMusicStyles = useCallback(async () => {
    toggleLoading(true);
    try {
      const response = await Assets.getGenresList();
      if (response && response.length > 0) {
        const options = [];
        response.forEach((value) => {
          if (parseInt(value.ID) !== 0) {
            options.push({ value: value.ID, label: value.Name });
          }
        });
        if (options && options.length > 0) { setGenres(options); }
      }
    } catch (err) {
      toast.error(`${Strings('error_while_getting_genres')} [ID==04]`);
    }
    toggleLoading(false);
  }, [toggleLoading]);
  useEffect(() => { getMusicStyles() }, [getMusicStyles]);

  const selectGenre = useCallback(async (id) => {
    if (id) {
      toggleLoading(true);

      // Getting media pack
      const newMedia = await RemixHelper.getMediaPackImagesFromGenre({ genre: id, un: authenticated.un, al: authenticated.al });
      if (newMedia) {
        let media = remixMedia;
        if (!remixMedia) { media = []; }
        media = media.concat(newMedia);
        setRemixMedia(media);
      }

      // Getting style
      if (!style) {
        let localStyle;
        try { localStyle = await RemixHelper.getStyleFromGenre({ genre: id }); }
        catch (err) { console.error(err); }
        if (localStyle) {
          const styles = await Assets.getStyle(localStyle);
          const catsImages = await Assets.getCatImages();

          let generatedRandomStyle = await RemixHelper.randomizeStyle(styles, catsImages);
          if (generatedRandomStyle) {
            setStyle(generatedRandomStyle);
          }
        }
      }

      toggleLoading(false);
    }
  }, [authenticated, toggleLoading, remixMedia, style]);

  const removeOriginalSong = useCallback(() => { setModalRemoveOriginalSongOpen(true); }, [setModalRemoveOriginalSongOpen]);
  const confirmRemoveOriginalSong = useCallback(() => { setOriginalSong(); }, [setOriginalSong]);

  useEffect(() => {
    const subscription = watch((value) => {
      let hasToBlock = false;
      if (value.title) { hasToBlock = true; }
      if (value.description) { hasToBlock = true; }
      if (createMode) {
        setIsBlocking(hasToBlock);
      }
    });
    return () => subscription.unsubscribe();
  }, [createMode, watch]);

  useEffect(() => {
    if (createMode && remixMedia && remixMedia.length > 0) {
      setIsBlocking(true);
    }
  }, [createMode, remixMedia]);

  // Prevent browser reload
  useEffect(() => {
    const onUnload = (event) => {
      if (isBlocking) {
        event.preventDefault();
        event.returnValue = '';
      }
    }
    window.addEventListener('beforeunload', onUnload);
    return () => window.removeEventListener('beforeunload', onUnload);
  }, [isBlocking]);

  return (
    <>
      <Container fluid className='my-4'>
        <Row>

          <Col sm={(createMode) ? 12 : 8} className='mb-2'>
            <h1 className='h3'>
              {createMode && Strings('create_your_music_video_and_links_webpage')}
              {editMode && Strings('edit_your_music_video_webpage')}
            </h1>
            <p className='text-muted'>
              {createMode && Strings('create_music_video_page_description')}
              {editMode && Strings('edit_music_video_page_description')}
            </p>
          </Col>

          {editMode && (
            <Col sm={4} className='d-flex justify-content-end align-items-start'>
              <RemixExport label={Strings('export_to_mp4')} remixPars={remixPars} size='lg' />
            </Col>
          )}

          <Col sm={12} md={7} >

            <Row className='mb-4'>
              <Col>
                <div
                  className={`d-flex justify-content-center align-items-center rounded shadow pb-video-create-1 ${(editMode) ? 'edit' : 'create cursor-pointer'}`}
                  onClick={() => { if (createMode) { setModalManageVideoOpen(true); } }}
                >
                  {editMode && remixPars && (
                    <img
                      src={getRemixCover(remixPars)}
                      alt={remixPars.rde}
                      title={remixPars.rti}
                    />
                  )}

                  <div className='text-center'>
                    <div className='mb-4'>
                      <img
                        src={PlayIcon}
                        alt='Play icon'
                        className={`${(editMode) ? 'cursor-pointer' : ''}`}
                        onClick={() => {
                          if (editMode) { setModalPluginOpen(true); }
                        }}
                      />
                      <ModalPlugin open={modalPluginOpen} setOpen={setModalPluginOpen} remix={remixPars} />
                    </div>

                    <Button
                      className='pb-btn-1'
                      size='lg'
                      onClick={() => setModalManageVideoOpen(true)}
                    >
                      {createMode && Strings('my_video_details')}
                      {editMode && Strings('manage_video')}
                    </Button>
                    <ModalManageVideo
                      open={modalManageVideoOpen}
                      setOpen={setModalManageVideoOpen}
                      createMode={createMode}
                      editMode={editMode}
                      remixMedia={remixMedia}
                      setRemixMedia={setRemixMedia}
                      remixPars={remixPars}
                      remixStyle={remixStyle}
                      parentStyle={style}
                      setParentStyle={setStyle}
                      parentSelectCallback={(style) => {
                        if (editMode) { updateStyle(style); }
                      }}
                    />

                    {remixMedia && remixMedia.length > 0 && (
                      <div className='text-muted'><small>{remixMedia.length} {Strings('media_s_selected')}</small></div>
                    )}
                  </div>
                </div>
              </Col>
            </Row>

            <Form>
              <Row>
                <Col>
                  <FormGroup>
                    <Label className='pb-label-1'>{Strings('title')}</Label>
                    <input
                      className='form-control shadow pb-input-1'
                      name='title'
                      {...register('title', { required: true })}
                      onBlur={() => {
                        const valueTitle = getValues('title');
                        const titleToSet = (valueTitle) ? valueTitle : Strings('title');
                        setTitle(titleToSet);
                      }}
                    />
                    {errors && errors.title && errors.title.type === 'required' && <p role='alert' className='text-danger txt-small-1'>{Strings('title_is_required')}</p>}
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col>
                  <FormGroup>
                    <Label className='pb-label-1'>{Strings('description')}</Label>
                    <input
                      className='form-control shadow pb-input-1'
                      name='description'
                      {...register('description', { required: true })}
                      onBlur={() => {
                        const valueDescription = getValues('description');
                        const descriptionToSet = (valueDescription) ? valueDescription : Strings('description');
                        setDescription(descriptionToSet);
                      }}
                    />
                    {errors && errors.description && errors.description.type === 'required' && <p role='alert' className='text-danger txt-small-1'>{Strings('description_is_required')}</p>}
                  </FormGroup>
                </Col>
              </Row>
              {createMode && (
                <Row>
                  <Col>
                    <FormGroup>
                      <Label className='pb-label-1'>{Strings('music_style')}</Label>
                      <Select
                        options={genres}
                        onChange={(evt) => {
                          const { value } = evt;
                          selectGenre(value);
                        }}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              )}

              <Row><Col><hr /></Col></Row>

              {createMode && (
                <>
                  <Row className='mb-2'>
                    <Col md={12} className='mb-3'>
                      <Label className='pb-label-2'>{Strings('my_song')}</Label>
                    </Col>
                    <Col md={6}>
                      <div className='d-grid'>
                        <ModalOriginalSong
                          originalSong={originalSong}
                          callback={(obj) => { if (obj) { setOriginalSong(obj); } }}
                          removeOriginalSong={removeOriginalSong}
                        />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className='d-grid'>
                        <ModalCoverPhoto photo={coverPhoto} setPhoto={setCoverPhoto} />
                      </div>
                    </Col>
                  </Row>

                  {originalSong && (
                    <Row className='mb-2'>
                      <Col>
                        <OriginalSongCard1 originalSong={originalSong} removeOriginalSong={removeOriginalSong} />
                      </Col>
                    </Row>
                  )}

                  <Row><Col><hr /></Col></Row>
                </>
              )}

              <Row>
                <Col md={12} className='mb-3'>
                  <Label className='pb-label-2'>{Strings('my_song_webpage')}</Label>
                </Col>
                <Col md={6}>
                  <div className='d-grid'>
                    <Button type='button' color='secondary' onClick={toggleModalAddLink} className='pb-btn-1 btn-block'>
                      + {Strings('add_link')}
                    </Button>
                  </div>
                </Col>
                <Col md={6}>
                  <div className='d-grid'>
                    <Button onClick={() => setModalSkinOpen(true)} className='btn-secondary btn-block'>
                      {createMode && <span>{Strings('choose_skin')}</span>}
                      {editMode && <span>{Strings('change_skin')}</span>}
                    </Button>
                  </div>
                </Col>
              </Row>

              <Row><Col><hr /></Col></Row>

              {links && links.map((item, index) => (
                <Row key={item.id} className='mb-3'>
                  <Col>
                    <Card className='border-0 shadow-lg'>
                      <CardBody>
                        <FormGroup>
                          <input
                            className='pb-input-3 mb-3'
                            defaultValue={item.label}
                            name={`${item.id}_label`}
                            {...register(`${item.id}_label`)}
                            onBlur={() => {
                              const valueGetted = getValues(`${item.id}_label`);
                              const filtered = [];
                              links.forEach((link) => {
                                if (link.id === item.id) { link.label = valueGetted; }
                                filtered.push(link);
                              });
                              setLinks(filtered);
                            }}
                          />
                          <input
                            className='form-control pb-input-2'
                            defaultValue={item.url}
                            name={item.id}
                            {...register(item.id)}
                            onBlur={() => {
                              const valueGetted = getValues(item.id);
                              const filtered = [];
                              links.forEach((link) => {
                                if (link.id === item.id) { link.url = valueGetted; }
                                filtered.push(link);
                              });
                              setLinks(filtered);
                            }}
                          />
                        </FormGroup>
                        <div className='d-flex justify-content-end'>
                          <IoTrashBinOutline size={20} className='cursor-pointer' onClick={() => removeLink(index)} />
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              ))}

              <Row className='mt-3'>
                <Col className='d-flex justify-content-center'>
                  <Button1
                    color='secondary'
                    size='lg'
                    className='mr-10px'
                    onClick={() => history.push('/dashboard')}
                  >
                    {Strings('cancel')}
                  </Button1>
                  {createMode && (
                    <Button1
                      size='lg'
                      className='pb-btn-1'
                      onClick={handleSubmit(onSubmitCreate)}
                      loading={loading}
                      disabled={loading}
                    >
                      {Strings('create')} {labelCreditsCost}
                    </Button1>
                  )}
                  {editMode && (
                    <Button1
                      size='lg'
                      className='pb-btn-1'
                      onClick={handleSubmit(onSubmitEdit)}
                      loading={loading}
                      disabled={loading}
                    >
                      {Strings('save')}
                    </Button1>
                  )}
                </Col>
              </Row>
            </Form>

          </Col>

          <Col md={5}>
            <StickyBox>
              <TinyPagePreview
                skin={skin}
                createMode={createMode}
                editMode={editMode}
                remix={remixPars}
                links={links}
                title={title}
                description={description}
                playerCallback={() => { if (createMode) { setModalManageVideoOpen(true); } }}
                playRemixCallback={() => { if (editMode) { setModalPluginOpen(true); } }}
              />
            </StickyBox>
          </Col>

        </Row>
      </Container>

      <Modal isOpen={modalAddLinkOpen} toggle={toggleModalAddLink}>
        <ModalHeader toggle={toggleModalAddLink}>
          {Strings('add_link')}
        </ModalHeader>
        <ModalBody className='text-center justify-content-center'>
          <Row>
            <Col>
              <Button
                type='button'
                onClick={() => {
                  setSocialNetworkLinkInsert('instagram');
                  setSocialNetworkLinkInsertType('account');
                  setModalSocialNetworkLinkOpen(true);
                  setModalAddLinkOpen(false);
                }}
                className='m-1 pb-btn-1'
              >
                <SiInstagram size='1.2em' /> {Strings('instagram')}
              </Button>
              <Button
                type='button'
                onClick={() => {
                  setSocialNetworkLinkInsert('facebook');
                  setSocialNetworkLinkInsertType('account_page');
                  setModalSocialNetworkLinkOpen(true);
                  setModalAddLinkOpen(false);
                }}
                className='m-1 pb-btn-1'
              >
                <SiFacebook size='1.2em' /> {Strings('facebook')}
              </Button>
              <Button
                type='button'
                onClick={() => {
                  setSocialNetworkLinkInsert('youtube');
                  setSocialNetworkLinkInsertType('account_page');
                  setModalSocialNetworkLinkOpen(true);
                  setModalAddLinkOpen(false);
                }}
                className='m-1 pb-btn-1'
              >
                <SiYoutube size='1.2em' /> {Strings('youtube')}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                type='button'
                onClick={() => {
                  setSocialNetworkLinkInsert('tiktok');
                  setSocialNetworkLinkInsertType('account');
                  setModalSocialNetworkLinkOpen(true);
                  setModalAddLinkOpen(false);
                }}
                className='m-1 pb-btn-1'
              >
                <SiTiktok size='1.2em' /> {Strings('tik_tok')}
              </Button>
              <Button
                type='button'
                onClick={() => {
                  setSocialNetworkLinkInsert('twitter');
                  setSocialNetworkLinkInsertType('account');
                  setModalSocialNetworkLinkOpen(true);
                  setModalAddLinkOpen(false);
                }}
                className='m-1 pb-btn-1'
              >
                <SiTwitter size='1.2em' /> {Strings('twitter')}
              </Button>
              <Button
                type='button'
                onClick={() => {
                  setModalWhatsappOpen(true);
                  setModalAddLinkOpen(false);
                }}
                className='m-1 pb-btn-1'
              >
                <SiWhatsapp size='1.2em' /> {Strings('whatsapp')}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                type='button'
                onClick={() => {
                  setSocialNetworkLinkInsert('spotify');
                  setSocialNetworkLinkInsertType('url');
                  setModalSocialNetworkLinkOpen(true);
                  setModalAddLinkOpen(false);
                }}
                className='m-1 pb-btn-1'
              >
                <SiSpotify size='1.2em' /> {Strings('spotify')}
              </Button>
              <Button
                type='button'
                onClick={() => {
                  setSocialNetworkLinkInsert('applemusic');
                  setSocialNetworkLinkInsertType('url');
                  setModalSocialNetworkLinkOpen(true);
                  setModalAddLinkOpen(false);
                }}
                className='m-1 pb-btn-1'
              >
                <SiApplemusic size='1.2em' /> {Strings('apple_music')}
              </Button>
              <Button
                type='button'
                onClick={() => {
                  setSocialNetworkLinkInsert('youtubemusic');
                  setSocialNetworkLinkInsertType('url');
                  setModalSocialNetworkLinkOpen(true);
                  setModalAddLinkOpen(false);
                }}
                className='m-1 pb-btn-1'
              >
                <SiYoutubemusic size='1.2em' /> {Strings('youtube_busic')}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                type='button'
                onClick={() => {
                  setSocialNetworkLinkInsert('custom');
                  setSocialNetworkLinkInsertType('url');
                  setModalSocialNetworkLinkOpen(true);
                  setModalAddLinkOpen(false);
                }}
                className='m-1 pb-btn-1'
              >
                <IoLinkOutline size='1.2em' /> {Strings('website')}
              </Button>
            </Col>
          </Row>
        </ModalBody>
      </Modal>

      <ModalSkin
        open={modalSkinOpen}
        setOpen={setModalSkinOpen}
        parentSkin={skin}
        setParentSkin={setSkin}
        callback={(skin) => {
          setModalSkinOpen(false);
          if (editMode) {
            const data = getValues();
            data.scapeSkin = true;
            data.skin = skin;
            onSubmitEdit(data);
          }
        }}
        createMode={createMode}
        editMode={editMode}
      />

      <ModalWhatsapp
        open={modalWhatsappOpen}
        setOpen={setModalWhatsappOpen}
        callback={(phone_number) => {
          addLink('whatsapp', phone_number);
          setModalWhatsappOpen(false);
          setModalAddLinkOpen(false);
        }}
      />

      <ModalSocialNetworkLink
        open={modalSocialNetworkLinkOpen}
        setOpen={setModalSocialNetworkLinkOpen}
        socialNetwork={socialNetworkLinkInsert}
        type={socialNetworkLinkInsertType}
        callback={(label, url) => {
          addLink('direct', null, label, url);
          setModalSocialNetworkLinkOpen(false);
          setModalAddLinkOpen(false);
        }}
      />

      <ModalRemoveOriginalSong
        open={modalRemoveOriginalSongOpen}
        setOpen={setModalRemoveOriginalSongOpen}
        confirm={confirmRemoveOriginalSong}
      />

      <Prompt when={isBlocking} message={Strings('are_you_sure_leave_page')} />
    </>
  );
}
